import clsx from "clsx";
import React, { DetailedHTMLProps, FC, HTMLAttributes, PropsWithChildren } from "react";

import { ButtonGenericProps } from "./button-generic-props";
import { getButtonClassName } from "./get-button-class-name";

export interface ClickableProps
  extends Pick<
      DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
      "className" | "onClick"
    >,
    ButtonGenericProps {
  disabled?: boolean;
}

export const Clickable: FC<PropsWithChildren<ClickableProps>> = ({
  variant = "neutral",
  size = "md",
  className: _className,
  children,
  fullWidth,
  disabled,
  ...props
}) => {
  const className = getButtonClassName({
    size,
    variant,
    fullWidth,
    disabled: disabled,
    customClassName: _className,
  });

  return (
    <div className={clsx("flex items-center cursor-pointer", className)} {...props}>
      {children}
    </div>
  );
};
